import { render, staticRenderFns } from "./CreateLabelModal.vue?vue&type=template&id=8a22bc9a&scoped=true"
import script from "./CreateLabelModal.vue?vue&type=script&lang=js"
export * from "./CreateLabelModal.vue?vue&type=script&lang=js"
import style0 from "./CreateLabelModal.vue?vue&type=style&index=0&id=8a22bc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a22bc9a",
  null
  
)

export default component.exports